var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65833 14.1916C4.93056 13.875 4.29722 13.4472 3.75833 12.9083C3.21944 12.3694 2.79167 11.7361 2.475 11.0083C2.15833 10.2805 2 9.49996 2 8.66663H3.33333C3.33333 9.96663 3.78611 11.0694 4.69167 11.975C5.59722 12.8805 6.7 13.3333 8 13.3333C9.3 13.3333 10.4028 12.8805 11.3083 11.975C12.2139 11.0694 12.6667 9.96663 12.6667 8.66663C12.6667 7.36663 12.2139 6.26385 11.3083 5.35829C10.4028 4.45274 9.3 3.99996 8 3.99996H7.9L8.93333 5.03329L8 5.99996L5.33333 3.33329L8 0.666626L8.93333 1.63329L7.9 2.66663H8C8.83333 2.66663 9.61389 2.82496 10.3417 3.14163C11.0694 3.45829 11.7028 3.88607 12.2417 4.42496C12.7806 4.96385 13.2083 5.59718 13.525 6.32496C13.8417 7.05274 14 7.83329 14 8.66663C14 9.49996 13.8417 10.2805 13.525 11.0083C13.2083 11.7361 12.7806 12.3694 12.2417 12.9083C11.7028 13.4472 11.0694 13.875 10.3417 14.1916C9.61389 14.5083 8.83333 14.6666 8 14.6666C7.16667 14.6666 6.38611 14.5083 5.65833 14.1916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon_reload.f4dae2541db4a19024eacce80a3dbb1a.svg";
export { ForwardRef as ReactComponent };